export const PAKISTAN_TIME_ZONE = 'Asia/Karachi';

// API DATETIME columns are stored by the server in UTC but are returned without
// an offset (for example, "2026-09-20 10:26:07"). Treat those values as UTC so
// browsers do not reinterpret them in their own local timezone.
export function toPakistanDate(value = new Date()) {
  if (value instanceof Date) return value;
  if (typeof value === 'string') {
    const hasTimezone = /(?:Z|[+-]\d\d:?\d\d)$/i.test(value);
    const normalized = value.includes('T') ? value : value.replace(' ', 'T');
    return new Date(hasTimezone ? normalized : `${normalized}Z`);
  }
  return new Date(value);
}

export function formatPakistanDateTime(value, options = {}) {
  return toPakistanDate(value).toLocaleString('en-PK', {
    timeZone: PAKISTAN_TIME_ZONE,
    ...options,
  });
}

export function formatPakistanDate(value, options = {}) {
  return toPakistanDate(value).toLocaleDateString('en-PK', {
    timeZone: PAKISTAN_TIME_ZONE,
    ...options,
  });
}

export function formatPakistanTime(value, options = {}) {
  return toPakistanDate(value).toLocaleTimeString('en-PK', {
    timeZone: PAKISTAN_TIME_ZONE,
    ...options,
  });
}

export function pakistanToday() {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: PAKISTAN_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(new Date());
  const get = (type) => parts.find((part) => part.type === type)?.value;
  return `${get('year')}-${get('month')}-${get('day')}`;
}
